import type { FC } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { stepToIcon, stepToLabel } from '@/features/experience-shell/utils'
import { ExperienceStepKeyName } from '@/features/experience-view-only/types'
import { useTranslation } from '@/translations/i18n'

export const StepsNavigation: FC<{
	currentStep: ExperienceStepKeyName
	onStepClick: (step: ExperienceStepKeyName) => void
}> = ({ currentStep, onStepClick }) => {
	const { t } = useTranslation()

	return (
		<aside className='flex flex-col gap-2 border-neutral-300 border-r px-4 py-8'>
			{ExperienceStepKeyName.options.map((step) => {
				const StepIcon = stepToIcon[step]
				const isActive = currentStep === step
				return (
					<ButtonLegacy
						className={`h-11 justify-between px-2 font-normal text-neutral-600 no-underline transition-[background] hover:bg-neutral-50 [&>svg]:h-auto [&>svg]:w-auto [&_svg]:h-6 [&_svg]:w-6 ${
							isActive
								? 'bg-neutral-50 font-medium text-neutral-900 outline-2 outline-neutral-900'
								: ''
						}`}
						key={step}
						onClick={() => onStepClick(step)}
						type='button'
						variant='tertiary'
					>
						<div className='flex items-center gap-2'>
							<StepIcon />
							{t(stepToLabel[step])}
						</div>
					</ButtonLegacy>
				)
			})}
		</aside>
	)
}
